import { Tooltip, Typography } from '@mui/material';

interface Props {
  names: string[];
  emptyText: string;
  pluralText: string;
}

export const NamesListTooltip = ({ names, emptyText, pluralText }: Props) => {
  const render = () => {
    switch (true) {
      case names.length === 1:
        return <Typography variant="body2">{names[0]}</Typography>;

      case names.length > 1:
        return (
          <Tooltip
            title={names.map(name => (
              <Typography key={name} variant="body2">
                {name}
              </Typography>
            ))}>
            <span>
              <Typography
                variant="body2"
                sx={{
                  textDecoration: 'underline',
                }}>
                {`${names.length} ${pluralText}`}
              </Typography>
            </span>
          </Tooltip>
        );

      default:
        return (
          <Typography variant="body2" color="textSecondary">
            {emptyText}
          </Typography>
        );
    }
  };

  return render();
};
